module.exports = __webpack_public_path__ + "img/racecard-icon.b75d6161.svg";